import * as actions from './actions';
import { Action } from 'redux';
import { TermsState } from '@webapp/store/terms/state';

export class UpdateTerms implements Action {
  readonly type = actions.UPDATE_TERMS;

  constructor(public termName: keyof TermsState, public newDate: Date) {}
}

export class CheckTerms implements Action {
  readonly type = actions.CHECK_TERMS;
}

export class UpdateAgreement implements Action {
  readonly type = actions.UPDATE_AGREEMENT;

  constructor(public agreedDate: Date) {}
}

export type TermsActions = UpdateTerms | CheckTerms | UpdateAgreement;
